import { useCallback, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { BookingCruise, CRUISE_STATUS_LABEL } from "src/store/reducers/bookings";
import AddCruiseBookingCanvas from "./AddCruiseBookingCanvas";
import EditCruiseBookingCanvas from "./EditCruiseBookingCanvas";

interface ListBookingCruisesProps {
  bookingId: string;
  bookingCruiseData: BookingCruise[];
  setDeleteCruiseId: React.Dispatch<React.SetStateAction<string | undefined>>;
}
function ListBookingCruises({
  bookingId,
  bookingCruiseData,
  setDeleteCruiseId,
}: ListBookingCruisesProps) {
  const [editCruiseId, setEditCruiseId] = useState<number>();
  const [showCruiseAddModal, setShowCruiseAddModal] = useState(false);
  const [show, setShow] = useState(bookingCruiseData.length > 0);
  const toggleShow = useCallback(() => {
    setShow((show) => !show);
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card h-auto">
              <div className="card-header">
                <h4
                  className="heading mb-0 link"
                  role="button"
                  onClick={toggleShow}
                >
                  {show ? (
                    <span className="btn-icon-start">
                      <i className="fa fa-minus color-info"></i>
                    </span>
                  ) : (
                    <span className="btn-icon-start">
                      <i className="fa fa-plus color-info"></i>
                    </span>
                  )}
                  Cruises
                </h4>
                <Link
                  to={"#"}
                  className="btn btn-primary btn-sm"
                  data-bs-toggle="offcanvas"
                  onClick={() => setShowCruiseAddModal(true)}
                >
                  + Add Cruise
                </Link>
              </div>
              <div className={!show ? "card-body d-none" : "card-body"}>
                {bookingCruiseData.length > 0 ? (
                  <div className="table-responsive active-projects">
                    <div
                      id="projects-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="projects-tbl"
                        className="table table-hover dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th>Cruise Line</th>
                            <th>Ship Name</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Departure</th>
                            <th>Arrival</th>
                            <th>Cabin</th>
                            <th>Fare</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingCruiseData?.map((cruiseData, index) => (
                            <tr key={cruiseData.id}>
                              <td>{cruiseData.cruise_line?.cruise_line_name}</td>
                              <td>{cruiseData.ship_name}</td>
                              <td>{cruiseData.departure_port}</td>
                              <td>{cruiseData.arrival_port}</td>
                              <td>
                                {new Date(
                                  cruiseData.departure_datetime
                                ).toLocaleString('en-IN')}
                              </td>
                              <td>
                                {new Date(
                                  cruiseData.arrival_datetime
                                ).toLocaleString('en-IN')}
                              </td>
                              <td>{cruiseData.cabin_type}</td>
                              <td>{cruiseData.fare}</td>
                              <td>{CRUISE_STATUS_LABEL[cruiseData.status]}</td>
                              <td>
                                <NavLink
                                  className="btn btn-primary shadow btn-xs sharp me-1"
                                  onClick={() => setEditCruiseId(index)}
                                  to={`#`}
                                  title="Edit"
                                >
                                  <i className={`fas fa-pen`} />
                                </NavLink>{" "}
                                <NavLink
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => {
                                    setDeleteCruiseId(cruiseData.id);
                                  }}
                                  to={`#`}
                                  title="Delete"
                                >
                                  <i className={`fas fa-x`} />
                                </NavLink>{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    &nbsp;
                    <strong>Add cruises for this booking </strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddCruiseBookingCanvas
        Title={"Add Cruise"}
        show={showCruiseAddModal}
        bookingId={bookingId}
        setShow={setShowCruiseAddModal}
      />
      <EditCruiseBookingCanvas
        editId={
          typeof editCruiseId !== "undefined"
            ? bookingCruiseData?.[editCruiseId]?.id
            : ""
        }
        Title={"Edit Cruise"}
        data={
          typeof editCruiseId !== "undefined"
            ? bookingCruiseData?.[editCruiseId]
            : undefined
        }
        hide={() => setEditCruiseId(undefined)}
      />
    </>
  );
}

export default ListBookingCruises;
